import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getOtherCharge(params) {
  return request({
    url: URL.booking.airCargoDoc.getOtherCharge,
    method: 'get',
    params: params
  })
}

// 更新空运提单
export function updateAirCargoDoc(data, params) {
  return request({
    url: URL.booking.airCargoDoc.updateAirCargoDoc,
    method: 'put',
    data,
    params
  })
}

// 投保 空出
export function toInsureForAe(data) {
  return request({
    url: URL.booking.airCargoDoc.toInsureForAe,
    method: 'post',
    data
  })
}
// 投保 空进
export function toInsureForAi(data) {
  return request({
    url: URL.booking.airCargoDoc.toInsureForAi,
    method: 'post',
    data
  })
}
